import PersonIcon from '@mui/icons-material/Person';
import { useRouter } from 'next/router';
import { useClientGroup } from '@/common/hooks/clientGroups';
import { useRouteParam } from '@/common/hooks/useRouteParam';
import { BaseSideNavigation } from '@/components/BaseSideNavigation/BaseSideNavigation';
import { Link } from '@/components/SideBar/components/Link';
import { TXM_BUYERS_PATH } from '@/constants/paths';
import { getClientLabels } from '@/views/Buyers/utils';
import { useMissingRequiredFields } from './SidebarContent.helpers';

export function SidebarContent() {
  const clientGroupId = useRouteParam('clientGroupId');
  const { basePath: txmBasePath } = useRouter();
  const basePath = `${txmBasePath}${TXM_BUYERS_PATH}/${clientGroupId}`;
  const { clientGroup } = useClientGroup(clientGroupId);
  const { missingAgreementFields, loading: isMissingFieldsLoading } =
    useMissingRequiredFields();

  const formattedClientList = clientGroup?.clients
    .map((client) => {
      const { label, secondaryLabel } = getClientLabels(client);
      return `${label} ${secondaryLabel ? `(${secondaryLabel})` : ''}`.trim();
    })
    .join(', ');

  return (
    <BaseSideNavigation
      Icon={<PersonIcon sx={{ color: 'grey.600' }} />}
      title={formattedClientList}
    >
      <Link
        path={`${basePath}/profile`}
        label="Buyer Profile"
        interactionId={clientGroupId}
        badgeTooltip="Buyer Profile missing required fields"
        formPath="profile"
      />
      <Link
        path={`${basePath}/buyer-agreement`}
        label="Buyer Agreement"
        interactionId={clientGroupId}
        badgeTooltip="Buyer Agreement missing required fields"
        formPath="buyer-agreement"
      />
      <Link
        path={`${basePath}/documents`}
        label="Documents"
        disabled={isMissingFieldsLoading || missingAgreementFields.length > 0}
      />
      <Link path={`${basePath}/offers`} label="Connected Offers" />
    </BaseSideNavigation>
  );
}
